import script from "./MilestonePageSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./MilestonePageSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./MilestonePageSkeleton.vue?vue&type=style&index=0&id=632ffab2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-632ffab2"]])

export default __exports__